module.exports = __webpack_public_path__ + "media/images/flags/32/Bahrain-d3b817d3a40f82a1c792b21b588b0d72.png";